<template>
	<div class="stretch-layout">
		<title-bar with-search :title="$t('param_label.members', clubStore.club.accepted_members_count, {count: clubStore.club.accepted_members_count})"
				   v-model="filter.search"/>

		<container md-full lg-full xl-full class="stretch-layout">
			<data-loader :url="`/v1/views/clubs/${clubStore.club.id}/members`"
						 :params="params"
						 :filter="filter"
						 v-model:total="visibleUsersCount"
						 :simple-paginated="false"
						 auth
						 on-scroll>

				<template #loading>
					<row tight>
						<column cols="6" sm="4" md="3" lg="2" v-for="userLoader in Math.min(clubStore.club.accepted_members_count, params.limit)"
								:key="'user-loader-' + userLoader">
							<user-card-skeleton/>
						</column>
					</row>
				</template>

				<template v-slot="{data}">
					<row tight v-adapt:height="{selector: '.user-card', xs: 6, sm: 4, md: 3, lg: 2, xl: 2}">
						<column cols="6" sm="4" md="3" lg="2" v-for="(member, memberKey) in data" :key="`member-card-${memberKey}-${member.id}`">
							<user-card :user="member" :color="clubStore.club.color ?? $config.public.colors.secondary" class="user-card">
								<template #image>
									<follow-icon-button :model="member" inactive-color="gray-100" class="absolute top-0 right-0"/>
								</template>
								<template #subtitle>
									<meta-text xx-small>
										{{ member.position_titles }}
									</meta-text>
								</template>
							</user-card>
						</column>
						<column cols="6" sm="4" md="3" lg="2" v-for="privateUserIndex in invisibleUsersCount" :key="`member-card-private-${privateUserIndex}`">
							<user-card :user="DefaultUser" :color="clubStore.club.color ?? $config.public.colors.secondary" class="user-card">
								<template #subtitle>
									<meta-text xx-small>{{ $t('label.member') }}</meta-text>
								</template>
							</user-card>
						</column>
					</row>
				</template>

				<template #missingsearch>
					<missing-info :icon="icons.member" card xs-tile sm-tile class="min-h-200" :text="$t('missing.member.search')"/>
				</template>
				<template #missing>
					<missing-info :icon="icons.member" card xs-tile sm-tile class="min-h-200"
								  :text="$t('missing.club.members', {name: clubStore.club.display_name})"/>
				</template>
			</data-loader>
		</container>
	</div>
</template>

<script setup lang="ts">
import {useClubStore} from "../../../../store/club";
import {mdiAccountMultiple} from "@mdi/js";
import {DefaultUser} from "@spoferan/spoferan-ts-core";

const {t} = useI18n();
const route = useRoute();
const clubStore = useClubStore();

const filter = ref({
	// The query to search for a specific member
	search: route.query.search
});

const visibleUsersCount = ref(clubStore.club.accepted_members_count);
const invisibleUsersCount = computed(() => {
	return Math.max(0, (clubStore.club.accepted_members_count - visibleUsersCount.value));
});

const icons = {
	member: mdiAccountMultiple
};

const params = {limit: 12};


useMeta({
	title: clubStore.buildPageTitle(t('view.clubs.members.index.title', {club: clubStore.club.display_name})),
	description: t('view.clubs.members.index.description', {club: clubStore.club.display_name}),
	noIndex: true
})

</script>

